module.exports = __webpack_public_path__ + "static/media/GR.c7112042.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/GR.svg
// module id = 265
// module chunks = 0